import { toast } from "react-hot-toast";
import { studentEndpoints } from "../apis";
import { apiConnector } from "../apiconnector";
import rzpLogo from "../../assets/Brand/cnt-academy-logo-icon-transparent.png";
import { setPaymentLoading } from "../../slices/courseSlice";

const {
  COURSE_PAYMENT_API,
  COURSE_VERIFY_API,
  SEND_PAYMENT_SUCCESS_EMAIL_API,
} = studentEndpoints;

function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;

    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

export async function buyCourse(
  token,
  courses,
  userDetails,
  navigate,
  dispatch,
  couponCode = null,
  billingInfo = null,
  captchaToken = null,
  setCaptchaToken,
) {
  const toastId = toast.loading("Loading...");
  try {
    // Initiate the order
    const orderResponse = await apiConnector(
      "POST",
      COURSE_PAYMENT_API,
      { courses, couponCode, billingInfo, captchaToken },
      { Authorization: `Bearer ${token}` },
    );

    if (orderResponse.data.isFree) {
      toast.success("Successfully enrolled");

      if (typeof setCaptchaToken === "function") {
        setCaptchaToken(null);
      }

      navigate("/dashboard/enrolled-courses");

      toast.dismiss(toastId);

      return;
    }

    // Load script
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js",
    );

    if (!res) {
      toast.error("Razorpay SDK failed to load");
      return;
    }

    if (!orderResponse.data.success) {
      throw new Error(orderResponse.data.message);
    }

    // Options
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      currency: orderResponse.data.message.currency,
      amount: `${orderResponse.data.message.amount}`,
      order_id: orderResponse.data.message.id,
      name: "CNT Academy",
      description: "Thank you for purchasing a CNT Academy course",
      image: rzpLogo,
      prefill: {
        name: `${userDetails.firstName}`,
        email: userDetails.email,
      },
      handler: function (response) {
        if (typeof setCaptchaToken === "function") {
          setCaptchaToken(null);
        }

        //  send successful email
        sendPaymentSuccessEmail(
          response,
          orderResponse.data.message.amount,
          token,
        );
        // Verify payment
        verifyPayment({ ...response, courses }, token, navigate, dispatch);
      },
    };

    // Initialize razorpay with options
    const razorpay = new window.Razorpay(options);

    // Open razorpay payment window
    razorpay.open();
    razorpay.on("payment failed", function (response) {
      if (typeof setCaptchaToken === "function") {
        setCaptchaToken(null);
      }

      toast.error("OOPS, payment failed");
      console.log(response.error);
    });
  } catch (error) {
    if (typeof setCaptchaToken === "function") {
      setCaptchaToken(null);
    }
    toast.error(
      error?.response?.data?.message ||
        "Could not start payment. Please try again.",
    );
  }
  toast.dismiss(toastId);
}

async function sendPaymentSuccessEmail(response, amount, token) {
  try {
    await apiConnector(
      "POST",
      SEND_PAYMENT_SUCCESS_EMAIL_API,
      {
        orderId: response.razorpay_order_id,
        paymentId: response.razorpay_payment_id,
        amount,
      },
      {
        Authorization: `Bearer ${token}`,
      },
    );
  } catch (error) {}
}

// Verify payment
async function verifyPayment(bodyData, token, navigate, dispatch) {
  const toastId = toast.loading("Verifying Payment...");
  dispatch(setPaymentLoading(true));

  try {
    const response = await apiConnector("POST", COURSE_VERIFY_API, bodyData, {
      Authorization: `Bearer ${token}`,
    });

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    toast.success("Payment Successful, you are added to the course");
    navigate("/dashboard/enrolled-courses");

    // dispatch(resetCart());
  } catch (error) {
    toast.error("Could not verify payment");
  }
  toast.dismiss(toastId);
  dispatch(setPaymentLoading(false));
}
